// removed by extract-text-webpack-plugin
module.exports = {"root":"_2uzWZWU","didYouMean":"_3dbXokl","suggestions":"_1wNA0rb","locationWrapper":"_2LFzwCx","location":"Uotl3Ty","or":"_2Xp7THH"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/DidYouMean/DidYouMean.less
 ** module id = 868
 ** module chunks = 0
 **/